var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M743,786.2c20.3,0,40.6-5.1,55.8-20.3c15.2-15.2,20.3-30.5,20.3-55.8s-5.1-40.6-20.3-55.8s-30.5-20.3-55.8-20.3 c-25.4,0-40.6,5.1-55.8,20.3s-20.3,30.5-20.3,55.8s5.1,40.6,20.3,55.8C702.4,781.1,722.7,786.2,743,786.2z M743,938.5 c25.4,0,50.8-5.1,71.1-20.3c20.3-10.2,40.6-30.5,50.8-50.8c-20.3-10.2-40.6-20.3-60.9-25.4c-20.3-5.1-40.6-10.2-66-10.2 s-45.7,5.1-66,10.2c-20.3,5.1-40.6,15.2-60.9,25.4c15.2,20.3,30.5,35.5,50.8,50.8C692.3,933.4,717.7,938.5,743,938.5z M489.2,1040 c-116.8-30.5-213.2-96.4-289.3-203S83.1,613.6,83.1,486.7V248.1c0-20.3,5.1-40.6,20.3-55.8c10.2-15.2,30.5-30.5,45.7-35.5 L453.7,45.1c10.2-5.1,25.4-5.1,35.5-5.1c10.2,0,25.4,0,35.5,5.1l304.6,111.7c20.3,5.1,35.5,20.3,45.7,35.5 c10.2,15.2,20.3,35.5,20.3,55.8v218.3c-15.2-5.1-30.5-15.2-50.8-20.3c-15.2-5.1-35.5-10.2-50.8-10.2V248.1L489.2,136.4L184.7,248.1 v238.6c0,40.6,5.1,81.2,15.2,116.8c10.2,35.5,25.4,76.1,45.7,111.7c20.3,35.5,40.6,71.1,71.1,101.5c25.4,30.5,55.8,55.8,91.4,76.1 c10.2,25.4,20.3,50.8,35.5,76.1C458.8,994.3,474,1019.7,489.2,1040C494.3,1034.9,494.3,1040,489.2,1040 C494.3,1040,489.2,1040,489.2,1040z M743,1040c-71.1,0-132-25.4-177.7-76.1c-50.8-50.8-76.1-111.7-76.1-177.7s25.4-132,76.1-177.7 c50.8-50.8,111.7-76.1,177.7-76.1s132,25.4,177.7,76.1c50.8,50.8,76.1,111.7,76.1,177.7s-25.4,132-76.1,177.7 C875,1014.6,814.1,1040,743,1040z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBlack);
export default __webpack_public_path__ + "static/media/admin-black.3afcb0448d595af7ebe49cf6879b40dd.svg";
export { ForwardRef as ReactComponent };